import {
  Button,
  ButtonLink,
  DatePickerFieldController,
  Stack,
  TextInputFieldController,
} from '@fukuri-admins/ui/common';
import { PasswordTextFieldController } from '@fukuri-admins/ui/common/Form/PasswordTextField/PasswordTextFieldController';
import { getUsersLink } from '~/utils/getLinks';
import { PaginatedSelectController } from '../../../../../src/component/PaginatedSelect/PaginatedSelectController';
import styles from './styles.module.scss';

type Props = {
  isButtonDisabled: boolean;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
  searchAction: React.ComponentProps<
    typeof PaginatedSelectController
  >['paginatedSelect']['searchAction'];
};

export const CreateUserFormPresentation: React.FC<Props> = ({
  isButtonDisabled,
  onSubmit,
  searchAction,
}) => (
  <form onSubmit={onSubmit}>
    <Stack direction='column' gap={24} width='466px'>
      <h2 className={styles.formTitle}>利用者の追加</h2>
      <PaginatedSelectController
        name='clientId'
        paginatedSelect={{
          searchAction,
          placeholder: '利用者を追加する対象の利用企業を選択します',
          isClearable: true,
        }}
        fieldWrapperProps={{
          labelType: 'required',
          labelText: '利用企業',
        }}
      />
      <TextInputFieldController
        name='fullName'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: '氏名',
        }}
        textInput={{
          placeholder: '山田',
        }}
      />
      <TextInputFieldController
        name='email'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: 'メールアドレス',
        }}
        textInput={{
          type: 'email',
          placeholder: 'xxx@xxxx.xx.xx',
        }}
      />
      <TextInputFieldController
        name='externalUserId'
        fieldWrapperProps={{
          labelType: 'optional',
          labelText: '外部ユーザID',
        }}
        textInput={{
          placeholder: 'xxxx',
        }}
      />
      <DatePickerFieldController
        name='billableFrom'
        fieldWrapperProps={{ labelText: '利用開始日', labelType: 'required' }}
        datePicker={{ fromDate: new Date() }}
      />
      <PasswordTextFieldController
        name='password'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: 'パスワード',
        }}
      />
      <PasswordTextFieldController
        name='passwordConfirmation'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: 'パスワード確認',
        }}
      />
      <Stack direction='row' gap={16}>
        <ButtonLink to={getUsersLink()} variant='outline' size='md'>
          キャンセル
        </ButtonLink>
        <Button type='submit' size='md' disabled={isButtonDisabled}>
          追加
        </Button>
      </Stack>
    </Stack>
  </form>
);
